export const ru = {
  // Header & Navigation
  nav: {
    home: "Главная",
    shop: "Магазин",
    about: "О нас",
    contact: "Контакты",
    login: "Войти",
    logout: "Выйти",
    myOrders: "Мои заказы",
    adminPanel: "Админ панель",
    allProducts: "Все товары",
    powerTools: "Аккумуляторы DeWalt",
    handTools: "Аккумуляторы Milwaukee",
    accessories: "Аккумуляторы Makita",
    toolsAccessories: "Инструменты и аксессуары"
  },

  // Home Page
  home: {
    heroLabel: "Профессиональные инструменты",
    heroTitle1: "Созданы надёжными.",
    heroTitle2: "Работай усерднее.",
    heroDescription: "Профессиональные строительные инструменты и оборудование, которым доверяют специалисты. Разработаны для производительности и долговечности.",
    shopNow: "Купить сейчас",
    learnMore: "Узнать больше",
    qualityGuaranteed: "Гарантия качества",
    qualityDesc: "Все товары с гарантией производителя",
    fastShipping: "Быстрая доставка",
    shippingDesc: "Бесплатная доставка при заказе от 500 PLN",
    expertSupport: "Экспертная поддержка",
    supportDesc: "Круглосуточная техническая помощь от профессионалов",
    browseLabel: "Обзор",
    categories: "Категории",
    viewAll: "Смотреть все",
    topPicks: "Лучший выбор",
    bestSellers: "Бестселлеры",
    shopAll: "Смотреть все",
    readyToBuild: "Готовы к строительству?",
    getRightTools: "Получите правильные инструменты для работы",
    ctaDescription: "Присоединяйтесь к тысячам профессионалов, которые доверяют Narzędzia Pro в своих строительных и ремонтных проектах. Качественные инструменты, конкурентные цены, профессиональная поддержка.",
    startShopping: "Начать покупки",
    powerToolsDesc: "Оригинальные и сменные батареи для инструментов DeWalt",
    handToolsDesc: "Оригинальные и сменные батареи для инструментов Milwaukee",
    accessoriesDesc: "Оригинальные и сменные батареи для инструментов Makita",
    toolsAccessoriesDesc: "Профессиональные инструменты и строительные аксессуары"
  },

  // Shop Page
  shop: {
    title: "Магазин",
    allProducts: "Все товары",
    sortBy: "Сортировать:",
    default: "По умолчанию",
    priceLowHigh: "Цена: по возрастанию",
    priceHighLow: "Цена: по убыванию",
    name: "Название",
    filters: "Фильтры",
    showing: "Показано",
    products: "товаров",
    noProducts: "Товары в этой категории не найдены."
  },

  // Product
  product: {
    bestseller: "Бестселлер",
    addToCart: "В корзину",
    inStock: "В наличии",
    available: "доступно",
    outOfStock: "Нет в наличии",
    backToShop: "Назад в магазин",
    features: "Характеристики",
    professionalGrade: "Профессиональное качество",
    manufacturerWarranty: "Гарантия производителя",
    fastDelivery: "Быстрая доставка",
    relatedProducts: "Похожие товары"
  },

  // Cart
  cart: {
    title: "Корзина",
    empty: "Ваша корзина пуста",
    emptyDesc: "Похоже, вы ещё не добавили товары.",
    continueShopping: "Продолжить покупки",
    orderSummary: "Итого заказа",
    subtotal: "Промежуточный итог",
    shipping: "Доставка",
    free: "Бесплатно",
    addMore: "Добавьте ещё на",
    forFreeShipping: "для бесплатной доставки",
    total: "Итого",
    proceedToCheckout: "Оформить заказ",
    loginToCheckout: "Войти",
    orLoginText: "или",
    noAccount: "Нет аккаунта?",
    register: "Зарегистрироваться"
  },

  // Checkout
  checkout: {
    title: "Оформление заказа",
    backToCart: "Назад в корзину",
    shippingInfo: "Информация о доставке",
    fullName: "Полное имя",
    streetAddress: "Адрес",
    city: "Город",
    postalCode: "Почтовый индекс",
    phone: "Номер телефона",
    placeOrder: "Оформить заказ",
    processing: "Обработка...",
    orderConfirmed: "Заказ подтверждён!",
    thankYou: "Спасибо за покупку.",
    orderId: "Номер заказа:",
    viewOrders: "Посмотреть заказы",
    items: "шт.",
    paymentMethod: "Способ оплаты",
    cashOnDelivery: "Наложенный платёж",
    payOnDelivery: "Оплата при получении",
    payNow: "Оплатить сейчас",
    success: "Спасибо за заказ!",
    successMessage: "Ваш заказ принят и обрабатывается.",
    orderNumber: "Номер заказа",
    paid: "Оплачено",
    pending: "Ожидает оплаты",
    continueShopping: "Продолжить покупки",
    emailRequired: "Email обязателен",
    deliveryMethod: "Способ доставки",
    inpostDesc: "24/7, получение за 48ч",
    dpdDesc: "Доставка до двери, 1-2 дня",
    dpdPickupDesc: "Пункт выдачи DPD",
    inpostLocker: "Номер пачкомата",
    inpostLockerRequired: "Укажите номер пачкомата",
    findLocker: "Найти пачкомат на"
  },

  // Auth
  auth: {
    login: "Войти",
    register: "Регистрация",
    createAccount: "Создать аккаунт",
    welcomeBack: "С возвращением! Введите данные для входа.",
    joinUs: "Присоединяйтесь и получите доступ к профессиональным инструментам.",
    email: "Email",
    password: "Пароль",
    confirmPassword: "Подтвердите пароль",
    fullName: "Полное имя",
    loggingIn: "Вход...",
    creatingAccount: "Создание аккаунта...",
    noAccount: "Нет аккаунта?",
    haveAccount: "Уже есть аккаунт?",
    demoCredentials: "Демо данные администратора:"
  },

  // Contact
  contact: {
    title: "Контакты",
    getInTouch: "Свяжитесь с нами",
    hereToHelp: "Мы здесь, чтобы помочь",
    description: "Есть вопросы о наших товарах или нужна консультация эксперта? Наша команда профессионалов готова помочь вам.",
    phone: "Телефон",
    email: "Email",
    address: "Адрес",
    hours: "Часы работы",
    sendMessage: "Отправить сообщение",
    yourName: "Ваше имя",
    message: "Сообщение",
    howCanWeHelp: "Как мы можем вам помочь?",
    sending: "Отправка...",
    messageSent: "Сообщение отправлено!",
    thankYouMessage: "Спасибо за обращение. Мы ответим в течение 24 часов.",
    sendAnother: "Отправить ещё сообщение"
  },

  // About
  about: {
    title: "О нас",
    heroTitle1: "Создано профессионалами,",
    heroTitle2: "Для профессионалов",
    ourStory: "Наша история",
    trustedPartner: "Надёжный партнёр с 2009 года",
    story1: "Narzędzia Pro была основана командой строительных профессионалов, которые были разочарованы отсутствием качественных поставщиков инструментов в Польше. Мы знали, что должен быть лучший способ.",
    story2: "То, что началось как небольшая операция по снабжению мастерской, выросло в одного из самых надёжных продавцов профессиональных инструментов в Польше. Мы остались верны нашим корням: качественные товары, честные цены и профессиональное обслуживание.",
    story3: "Сегодня мы обслуживаем тысячи профессионалов по всей стране — от независимых подрядчиков до крупных строительных фирм. Наше стремление к совершенству остаётся неизменным.",
    whyChooseUs: "Почему мы",
    ourValues: "Наши ценности",
    qualityFirst: "Качество прежде всего",
    qualityDesc: "Мы работаем только с проверенными производителями, которые соответствуют нашим строгим стандартам качества. Каждый инструмент протестирован, чтобы работать, когда вам это нужно.",
    expertTeam: "Команда экспертов",
    expertDesc: "Наш персонал — это опытные мастера, которые понимают ваши потребности. Мы говорим на вашем языке и знаем, что работает на стройплощадке.",
    professionalGrade: "Профессиональный класс",
    professionalDesc: "У нас есть инструменты, на которые профессионалы полагаются ежедневно. От электроинструментов до точных приборов, мы предлагаем бренды, которые доказали свою ценность.",
    fastDelivery: "Быстрая доставка",
    deliveryDesc: "Время — деньги на стройплощадке. Мы предлагаем отправку в тот же день и доставку на следующий день, чтобы ваши проекты шли по плану.",
    readyToStart: "Готовы начать?",
    browseSelection: "Просмотрите наш выбор профессиональных инструментов и оборудования. Вопросы? Наша команда здесь, чтобы помочь.",
    yearsExperience: "Лет опыта",
    satisfiedCustomers: "Довольных клиентов",
    productsCount: "Товаров",
    support: "Поддержка"
  },

  // Orders
  orders: {
    title: "Мои заказы",
    account: "Аккаунт",
    noOrders: "Нет заказов",
    noOrdersDesc: "Вы ещё не сделали ни одного заказа.",
    startShopping: "Начать покупки",
    orderId: "Номер заказа",
    date: "Дата",
    status: "Статус",
    total: "Итого",
    shippingAddress: "Адрес доставки",
    pending: "Ожидает",
    completed: "Выполнен",
    cancelled: "Отменён",
    items: "шт."
  },

  // Admin
  admin: {
    title: "Админ панель",
    dashboard: "Панель",
    products: "Товары",
    orders: "Заказы",
    contacts: "Сообщения",
    messages: "Сообщения",
    revenue: "Доход",
    addProduct: "Добавить товар",
    importCsv: "Импорт CSV",
    downloadTemplate: "Скачать шаблон CSV",
    importProducts: "Импортировать товары",
    importSuccess: "Импорт завершён успешно",
    importError: "Ошибка импорта",
    productsCreated: "товаров создано",
    productsFailed: "неудачных",
    selectCsvFile: "Выберите CSV файл",
    csvFormatInfo: "Формат: название, описание, цена, категория, url_изображения, наличие, бестселлер",
    editProduct: "Редактировать товар",
    createProduct: "Создать товар",
    updateProduct: "Обновить товар",
    productName: "Название товара",
    description: "Описание",
    price: "Цена (PLN)",
    stock: "Наличие",
    category: "Категория",
    imageUrl: "URL изображения",
    markAsBestseller: "Отметить как бестселлер",
    noOrders: "Нет заказов.",
    noMessages: "Нет сообщений.",
    shipTo: "Доставить:",
    contactMessages: "Сообщения",
    language: "Язык",
    selectAll: "Выбрать все",
    selected: "выбрано",
    deleteSelected: "Удалить выбранные",
    bulkDeleteConfirm: "Вы уверены, что хотите удалить выбранные товары?",
    productsDeleted: "товаров удалено",
    hideProduct: "Скрыть товар",
    showProduct: "Показать товар",
    hidden: "Скрыт",
    visible: "Виден",
    settings: "Настройки",
    siteSettings: "Настройки сайта",
    contactInfo: "Контактные данные",
    phone: "Телефон",
    email: "Email",
    address: "Адрес",
    workingHours: "Часы работы",
    socialMedia: "Соцсети",
    aboutUs: "О нас",
    aboutTitle: "Заголовок",
    aboutDescription: "Описание",
    aboutImage: "Изображение",
    homepage: "Главная страница",
    heroTitle1: "Главный заголовок 1",
    heroTitle2: "Главный заголовок 2",
    heroDescription: "Главное описание",
    policies: "Политики",
    shippingPolicy: "Политика доставки",
    returnsPolicy: "Политика возврата",
    faq: "FAQ",
    addFaq: "Добавить вопрос",
    question: "Вопрос",
    answer: "Ответ",
    polish: "Польский",
    russian: "Русский",
    saveSettings: "Сохранить настройки",
    settingsSaved: "Настройки сохранены"
  },

  // Footer
  footer: {
    description: "Профессиональные инструменты для профессионалов. Качество, которому можно доверять, производительность, на которую можно положиться.",
    quickLinks: "Быстрые ссылки",
    company: "Компания",
    contact: "Контакты",
    shopAll: "Все товары",
    trustedBy: "Нам доверяют профессионалы по всему миру",
    allRights: "Все права защищены.",
    terms: "Правила магазина",
    privacy: "Политика конфиденциальности"
  },

  // Common
  common: {
    loading: "Загрузка...",
    error: "Ошибка",
    success: "Успешно",
    cancel: "Отмена",
    save: "Сохранить",
    delete: "Удалить",
    deleteConfirm: "Вы уверены, что хотите удалить этот товар?",
    edit: "Редактировать",
    add: "Добавить",
    remove: "Удалить",
    qty: "Кол-во",
    price: "Цена",
    actions: "Действия"
  }
};
